import * as React from 'react';
import { NavLink, Redirect } from 'react-router-dom';
import { IGenre, IMedia, IPagination, EPeriod, ELanguage } from '../interfaces';
import Axios, { AxiosResponse } from 'axios';
import config from '../config';
import Track from '../components/items/Track';
import Pagination from '../components/common/Pagination';
import { transliterate } from '../utils/functions';
import { withTranslation, WithTranslation } from 'react-i18next';
import i18n from '../config/i18next';
import Helmet from 'react-helmet';

const CancelToken = Axios.CancelToken;
let cancel: any;

interface IState {
    genres: IGenre[],
    tracks: IMedia[],
    media: IMedia,
    isLoading: boolean,
    name: string,
    media_id: number,
    currentPage: number,
    totalPages: number,
    pages: IPagination,
    genre_id: number,
    isNotFound: boolean,
    isTracksLoading: boolean,
    showMore: boolean
}

interface IProps extends WithTranslation {
    match: any,
}

class AlbumView extends React.Component<IProps, IState> {
    private _isUnmounted: boolean = false;

    constructor(props: any) {
        super(props);

        this.state = {
            genres: [],
            tracks: [],
            media: null,
            isLoading: true,
            isTracksLoading: true,
            currentPage: 1,
            name: this.props.match.params.name,
            media_id: this.props.match.params.media_id,
            totalPages: 1,
            pages: null,
            genre_id: null,
            showMore: false,
            isNotFound: false,
        };

        this.onPageChange = this.onPageChange.bind(this);
    }

    async componentDidMount() {
        this.loadMedia();
        this.loadTracks();
        this.loadGenres();
    }

    async loadMedia() {
        let response: AxiosResponse = await Axios.get(`${config.site}/${i18n.language}/api/album/view?media_id=${this.state.media_id}`);

        if (!this._isUnmounted)
            if (response.data.status == "success") {
                this.setState({
                    media: response.data.media,
                    isLoading: false,
                });

            } else {
                this.setState({
                    isNotFound: true
                });
            }
    }

    async loadGenres() {
        let response: AxiosResponse = await Axios.get(`${config.site}/${i18n.language}/api/stat/track-genres`);

        if (!this._isUnmounted)
            this.setState({
                genres: response.data
            });
    }

    componentWillReceiveProps(props: any) {
        window.scrollTo({
            left: 0,
            top: 0,
            behavior: "auto"
        });

        this.setState({
            name: props.match.params.name,
            media_id: props.match.params.media_id,
            isLoading: true,
            isTracksLoading: true
        }, this.componentDidMount);
    }

    async loadTracks() {
        cancel && cancel();

        try {
            let response: AxiosResponse = await Axios.get(`${config.site}/${i18n.language}/api/album/tracks?media_id=${this.state.media_id}` + (this.state.pages ? `&${this.state.pages.pageParam}=${this.state.currentPage}` : ``), {
                cancelToken: new CancelToken(function executor(c) {
                    cancel = c;
                })
            });

            let { data } = response;

            let totalPages = response.data.pages.pageCount;

            if (!this._isUnmounted)
                this.setState({
                    tracks: data.tracks,
                    isTracksLoading: false,
                    pages: data.pages,
                    totalPages: totalPages,
                    currentPage: totalPages > 1 ? this.state.currentPage : 1
                });
        } catch (err) {

        }

    }

    componentWillUnmount() {
        this._isUnmounted = true;
    }

    onPageChange(page: number) {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });

        this.setState({
            currentPage: page,
            isTracksLoading: true,
            // films: []
        }, async () => {
            await this.loadTracks();

        });
    }

    render() {
        const { t } = this.props;

        return (
            <div className="i-body">
                {this.state.isNotFound && <Redirect to="/not-found" />}
                <Helmet>
                    {!this.state.isLoading && <title>{(this.state.media.artist ? this.state.media.artist.full : "") + " - " + this.state.media.name + " | " + window.location.host.toUpperCase() + " - Медиа портал в TAS-IX"}</title>}
                </Helmet>
                <div className="container login-page v-index">
                    <div className="wrapper">
                        <div className="row">
                            <div className="col-md-8 col-xs-12">
                                <ul className="submenu">
                                    <li className=""><NavLink to="/music">{t("Треки")}</NavLink></li>
                                    <li className="active"><NavLink to="/albums">{t("Альбомы")}</NavLink></li>
                                    <li className=""><NavLink to="/singers">{t("Испольнители")}</NavLink></li>
                                </ul>
                                <div className="wrap">
                                    {this.state.isLoading && <div className="carousel-placeholder" />}
                                    {!this.state.isLoading && <div className="row">
                                        <div className="col-md-3">
                                            <img src={this.state.media.fullImage} alt="" className="img-fluid img-responsive" />
                                        </div>
                                        <div className="col-md-9">
                                            <table style={{ marginTop: "15px" }}>
                                                <tbody>
                                                    {this.state.media.artist && <tr style={{ fontSize: "16px", padding: "5px" }}>
                                                        <td>{t("Испольнитель")}:</td>
                                                        <td style={{ paddingLeft: "10px" }}>
                                                            <NavLink className="" to={"/singer/" + transliterate(this.state.media.artist.full) + "/" + this.state.media.artist.person_id}>{this.state.media.artist ? this.state.media.artist.full : ""} </NavLink>
                                                        </td>
                                                    </tr>}
                                                    <tr style={{ fontSize: "16px", padding: "5px" }}>
                                                        <td>{t("Альбом")}:</td>
                                                        <td style={{ paddingLeft: "10px" }}>{this.state.media.name}</td>
                                                    </tr>
                                                    <tr style={{ fontSize: "16px", padding: "5px" }}>
                                                        <td>{t("Жанр")}:</td>
                                                        <td style={{ paddingLeft: "10px" }}>
                                                            {this.state.media.genre.map((genre: IGenre, index: number) => {
                                                                return (<NavLink to={"/music/" + genre.genre_id} key={index}>{genre.name} <span> </span></NavLink>);
                                                            })}
                                                        </td>
                                                    </tr>
                                                    <tr style={{ fontSize: "16px", padding: "5px" }}>
                                                        <td>{t("Год выпуска")}:</td>
                                                        <td style={{ paddingLeft: "10px" }}>{this.state.media.year}</td>
                                                    </tr>
                                                    <tr style={{ fontSize: "16px", padding: "5px" }}>
                                                        <td>{t("Архив")}:</td>
                                                        <td style={{ paddingLeft: "10px" }}>
                                                            <a href={`${config.site}/site/upload/${this.state.media_id}?type=download`} className="down" style={{ color: "#333333", fontSize: "14px" }}>
                                                                <img src="/img/download.png" alt="" /> {t("Скачать")} </a>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>}

                                    <div className="music_box tracks_list singer-tracks">
                                        {this.state.isTracksLoading && <div className="carousel-placeholder" />}

                                        <ul>
                                            {!this.state.isTracksLoading && this.state.tracks.map((track: IMedia, index: number) => {
                                                return (
                                                    <Track hideArtist index={(index + 1) + ((this.state.currentPage - 1) * 20)} track={track} key={index} />
                                                );
                                            })}
                                        </ul>
                                    </div>
                                    {this.state.tracks.length > 0 && this.state.totalPages > 1 && <Pagination currentPage={this.state.currentPage} totalPages={this.state.totalPages} onChange={this.onPageChange} />}
                                </div>
                            </div>
                            <div className="col-md-4 col-xs-12">
                                <div className="right_side">
                                    {this.state.isLoading && <div className="carousel-placeholder" />}
                                    {!this.state.isLoading && <div className="fast_link">
                                        <div className="title">{t("Жанры")}</div>
                                        <ul>
                                            {this.state.genres.map((genre: IGenre, index: number) => {
                                                return (
                                                    <li key={index}><NavLink to={"/music/" + genre.genre_id}>{genre.name}</NavLink></li>
                                                );
                                            })}
                                        </ul>
                                    </div>}
                                    <div className="banner235"></div>
                                    <div className="banner235"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withTranslation()(AlbumView);